import { render, staticRenderFns } from "./ActivationPage.vue?vue&type=template&id=a2dcc11e&"
import script from "./ActivationPage.vue?vue&type=script&lang=js&"
export * from "./ActivationPage.vue?vue&type=script&lang=js&"
import style0 from "./ActivationPage.vue?vue&type=style&index=0&id=a2dcc11e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports